module.exports = __webpack_public_path__ + "img/mpodi.30515fdf.jpg";